export function PrivacyPolicy(){
        return (
            <div style={{ textAlign: 'center', padding: '40px 20px', maxWidth: '600px', margin: '0 auto' }}>
                <h2>Privacy Policy. Why you need to register?</h2>
                We have a very strict security policy concerning your information. 
            
                Beneath there is a Privacy Policy. 

                What we do with your data. 
            
                We are a software development company started in Costa Rica since 1992. Our focus has been primarily on financial and management applications for small businesses. Afterwards, our focus of attention has been specializing in those applications for offering a complete set of tools that support several business cores. 
            </div>
        );
}

